module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gt-3d87ccc4e82ef502f1dd9f09414eb509.svg";